module.exports = __webpack_public_path__ + "static/headshot--terrace-baw-a47a15a759c3eba4d8dd970fc8759adb.jpg";